"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeesApi = void 0;
const runtime = require("../runtime");
/**
 *
 */
class FeesApi extends runtime.BaseAPI {
    /**
     * Get an estimated fee rate for STX transfer transactions. This a a fee rate / byte, and is returned as a JSON integer
     * Get estimated fee
     */
    async getFeeTransferRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/fees/transfer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an estimated fee rate for STX transfer transactions. This a a fee rate / byte, and is returned as a JSON integer
     * Get estimated fee
     */
    async getFeeTransfer(initOverrides) {
        const response = await this.getFeeTransferRaw(initOverrides);
        return await response.value();
    }
}
exports.FeesApi = FeesApi;
//# sourceMappingURL=FeesApi.js.map